module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/60c04cb50aa0aa4887eecc8cc4d70b47.png";